import React from "react"
import image from "images/padelappen-case.jpg"
import BlogPost from "components/BlogPost"

const content = (
  <React.Fragment>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum earum
      quisquam iste esse eveniet! Est, earum officiis dolorem modi, cum cumque
      quidem libero iure exercitationem ducimus ipsam molestias blanditiis
      accusantium. Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Voluptatum maiores quis eum. Consectetur vero porro tempore quos minus
      laboriosam alias explicabo perferendis animi cupiditate! Magni et dolore
      dicta magnam repellat.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum earum
      quisquam iste esse eveniet! Est, earum officiis dolorem modi, cum cumque
      quidem libero iure exercitationem ducimus ipsam molestias blanditiis
      accusantium. Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Voluptatum maiores quis eum. Consectetur vero porro tempore quos minus
      laboriosam alias explicabo perferendis animi cupiditate! Magni et dolore
      dicta magnam repellat.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum earum
      quisquam iste esse eveniet! Est, earum officiis dolorem modi, cum cumque
      quidem libero iure exercitationem ducimus ipsam molestias blanditiis
      accusantium. Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Voluptatum maiores quis eum. Consectetur vero porro tempore quos minus
      laboriosam alias explicabo perferendis animi cupiditate! Magni et dolore
      dicta magnam repellat.
    </p>
  </React.Fragment>
)

class PadelappenBlogPost extends React.Component {
  render() {
    return (
      <BlogPost
        title="SÅ SKAPADE VI PADELAPPEN"
        author="Dan Andréasson"
        date="26 April 2018"
        backgroundImage={image}
        backgroundColor="#3C40C6"
      >
        {content}
      </BlogPost>
    )
  }
}

export default PadelappenBlogPost



// WEBPACK FOOTER //
// ./src/pages/PadelappenBlogPost/index.jsx